import styled from "styled-components";
import { BASIC_DARK_GRAY } from "../../../constants/colors";
import { useAuth } from "../../../hooks/useAuth";
import { BackToMyPageButton } from "../../molecules/BackToMyPageButton";
import { CustomerInfoEditForm } from "../../organisms/form/CustomerInfoEditForm";
import { useCustomerInfoEdit } from "./hook";

export const CustomerInfoEdit: React.FC = () => {
  const { loggedInUser, handleAuthValidationError } = useAuth();
  const { handleCustomerInfoEdit } = useCustomerInfoEdit();

  return (
    <Container>
      <TitleWrapper>お客さま情報の編集</TitleWrapper>

      {loggedInUser && (
        <CustomerInfoEditForm
          name={loggedInUser.name}
          phoneNumber={loggedInUser.phoneNumber}
          handleAuthValidationError={handleAuthValidationError}
          handleSubmit={handleCustomerInfoEdit}
        />
      )}

      <ButtonWrapper>
        <BackToMyPageButton />
      </ButtonWrapper>
    </Container>
  );
};

const Container = styled.div`
  color: ${BASIC_DARK_GRAY};
  padding: 0 16px 57px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  text-align: left;
`;

const TitleWrapper = styled.div`
  font-size: 20px;
  padding: 43px 0 38px;
  display: flex;
  font-weight: 500;
  justify-content: center;
  line-height: 1;
  font-family: "Hiragino Sans";
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 40px;
`;
